<template>
    <client-page>

        <sub-visual
        sh="Contact"
        tabActive="Direction"
        bg="/images/sub/visual/sv1.png">
        </sub-visual>

        <section class="sub-section--first sub-section--last">
            <v-container>
                <h2 class="page-tit mb-lg-42">
                    Direction
                </h2>

                <iframe class="mb-12 mb-lg-24" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3171.3643506994827!2d127.21304991564394!3d37.35755484382564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b55ff1de75c53%3A0xf6c56394bc1ebfcf!2s673-10%20Opo-ro%2C%20Opo-eup%2C%20Gwangju-si%2C%20Gyeonggi-do!5e0!3m2!1sen!2skr!4v1665478598219!5m2!1sen!2skr" width="100%" height="400" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            
                <h3 class="tit mb-12 mb-lg-24 font-weight-semibold pl-10 pl-lg-38">
                    Head Office
                </h3>

                <div class="w-100 border-top border-color-point border-lg-2 page-text">
                    <div class="d-flex align-center px-10 px-lg-38 py-10 py-lg-14 border-bottom">
                        <p class="w-80px w-lg-120px d-flex align-center justify-center text-center color-point border border-color-point font-weight-semibold mr-12 mr-lg-20 h-30px px-8 px-lg-14">
                            Address
                        </p>
                        <p class="color-grey-51">
                            673-10, Oppo-ro, Opo-Eup, Gwangju-si, Gyeonggi-Do, Korea 464-909
                        </p>
                    </div>
                    <div class="d-flex align-center px-10 px-lg-38 py-10 py-lg-14 border-bottom">
                        <p class="w-80px w-lg-120px d-flex align-center justify-center text-center color-point border border-color-point font-weight-semibold mr-12 mr-lg-20 h-30px px-8 px-lg-14">
                            Tel
                        </p>
                        <p class="color-grey-51">
                            +82-31-765-2268
                        </p>
                    </div>
                    <div class="d-flex align-center px-10 px-lg-38 py-10 py-lg-14 border-bottom">
                        <p class="w-80px w-lg-120px d-flex align-center justify-center text-center color-point border border-color-point font-weight-semibold mr-12 mr-lg-20 h-30px px-8 px-lg-14">
                            FAX
                        </p>
                        <p class="color-grey-51">
                            +82-31-765-2389
                        </p>
                    </div>
                    <div class="d-flex align-center px-10 px-lg-38 py-10 py-lg-14 border-bottom">
                        <p class="w-80px w-lg-120px d-flex align-center justify-center text-center color-point border border-color-point font-weight-semibold mr-12 mr-lg-20 h-30px px-8 px-lg-14">
                            E-MAIL
                        </p>
                        <p class="color-grey-51">
                            ist@ist-co.kr
                        </p>
                    </div>
                </div>
            
            </v-container>

        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/en/sub/sub-visual.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
    },
};
</script>

<style lang="scss" scoped>
</style>